@if(loading()) {
<div class="link-preview link-preview--loading">
    <div class="link-preview__skeleton"></div>
</div>
}

@if(!loading() && !error() && preview()) {
<div class="link-preview link-preview--variant-2" (click)="openLink()">
    @if(preview()?.image && !imageError()) {
    <div class="link-preview__image-container">
        <img class="link-preview__image" [src]="preview()?.image" [alt]="preview()?.title || 'Preview'" loading="lazy"
            (error)="onImageError()" />
    </div>
    }
    <div class="link-preview__content">
        @if(preview()?.title) {
        <h4 class="link-preview__title">{{ preview()?.title }}</h4>
        }
        @if(preview()?.description) {
        <p class="link-preview__description">{{ preview()?.description }}</p>
        }
        <span class="link-preview__url">🔗 {{ getDisplayUrl() }}</span>
    </div>
</div>
}